function def(id, center, variance) {
    return { id, center, variance };
}
const WIDE = {
    centroid: 0.2,
    noise: 0.2,
    voicing: 0.2,
    energy: 0.2,
    transient: 0.2,
    flatness: 0.2,
    rolloff: 0.2,
    tilt: 0.2,
    spread: 0.2,
    crest: 0.2,
    flux: 0.2,
    zcr: 0.2,
    hnr: 0.2,
    pitchHz: 0,
    pitchClass: 0,
    pitchConf: 0,
};
const POP_VAR = {
    centroid: 0.15,
    noise: 0.15,
    voicing: 0.15,
    energy: 0.15,
    transient: 0.15,
    flatness: 0.15,
    rolloff: 0.15,
    tilt: 0.15,
    spread: 0.15,
    crest: 0.15,
    flux: 0.15,
    zcr: 0.15,
    hnr: 0.15,
    pitchHz: 0.15,
    pitchConf: 0.15,
    pitchClass: 0.15,
};
export const SEED_CLUSTERS = [
    def("hiss", {
        centroid: 0.7,
        noise: 0.75,
        voicing: 0.05,
        energy: 0.4,
        transient: 0.15,
        flatness: 0.75,
        rolloff: 0.8,
        tilt: 0.8,
        spread: 0.7,
        crest: 0.25,
        flux: 0.3,
        zcr: 0.8,
        hnr: 0.1,
        pitchHz: 0,
        pitchConf: 0,
        pitchClass: -1,
    }, WIDE),
    def("airy", {
        centroid: 0.45,
        noise: 0.5,
        voicing: 0.1,
        energy: 0.35,
        transient: 0.15,
        flatness: 0.6,
        rolloff: 0.5,
        tilt: 0.5,
        spread: 0.6,
        crest: 0.3,
        flux: 0.25,
        zcr: 0.55,
        hnr: 0.15,
        pitchHz: 0,
        pitchConf: 0,
        pitchClass: -1,
    }, WIDE),
    def("pop", {
        centroid: 0.4,
        noise: 0.4,
        voicing: 0.15,
        energy: 0.55,
        transient: 0.8,
        flatness: 0.55,
        rolloff: 0.45,
        tilt: 0.45,
        spread: 0.5,
        crest: 0.7,
        flux: 0.85,
        zcr: 0.4,
        hnr: 0.2,
        pitchHz: 0,
        pitchConf: 0,
        pitchClass: -1,
    }, POP_VAR),
    def("hum", {
        centroid: 0.12,
        noise: 0.15,
        voicing: 0.8,
        energy: 0.45,
        transient: 0.15,
        flatness: 0.15,
        rolloff: 0.12,
        tilt: 0.12,
        spread: 0.15,
        crest: 0.65,
        flux: 0.15,
        zcr: 0.1,
        hnr: 0.85,
        pitchHz: 0,
        pitchConf: 0.5,
        pitchClass: -1,
    }, WIDE),
];
